import { __assign, __rest } from "tslib";
import React, { cloneElement, useRef, Children } from 'react';
import { mergeRefs } from '../lib/mergeRefs';
import { forkFn } from '../lib/forkFn';
import { useUniqId } from '../useUniqId';
import { Tooltip } from './Tooltip';
import { useTooltipState } from './hooks/useTooltipState';
/**
 * Компонент используется для создания всплывающих подсказок.
 *
 * @param {TooltipStatefulProps} props Свойства компонента.
 */
export var TooltipStateful = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, _c = _a.defaultVisible, defaultVisible = _c === void 0 ? false : _c, propId = _a.id, _d = _a.trigger, trigger = _d === void 0 ? 'hover' : _d, openDelay = _a.openDelay, closeDelay = _a.closeDelay, props = __rest(_a, ["children", "content", "defaultVisible", "id", "trigger", "openDelay", "closeDelay"]);
    var uniqId = useUniqId('tooltip');
    var id = propId || uniqId;
    var _e = useTooltipState({ openDelay: openDelay, closeDelay: closeDelay, defaultVisible: defaultVisible }), visible = _e.visible, open = _e.open, close = _e.close, toggle = _e.toggle;
    var anchorRef = useRef(null);
    var child = Children.only(children);
    // В дальнейшем данный код можно вынести куда-то выше и использовать по аналогии с Popup и Modal.
    var triggers = Array.isArray(trigger) ? trigger : [trigger];
    var handlers = triggers.reduce(function (acc, trigger) {
        switch (trigger) {
            case 'click':
                acc.onClick = forkFn(child.props.onClick, function () { return toggle(); });
                break;
            case 'focus':
                acc.onFocus = forkFn(child.props.onFocus, function () { return open(); });
                acc.onBlur = forkFn(child.props.onBlur, function () { return close(); });
                break;
            case 'hover':
                acc.onMouseEnter = forkFn(child.props.onMouseEnter, function () { return open(); });
                acc.onMouseLeave = forkFn(child.props.onMouseLeave, function () { return close(); });
                break;
        }
        return acc;
    }, {});
    // Определяем тип ссылки в зависимости от типа потомка,
    // нативные элементы реализуют ref, лего-компоненты должны реализовывать innerRef.
    var refKey = typeof child.type === 'string' ? 'ref' : 'innerRef';
    var ref = child.props[refKey] === undefined ? anchorRef : mergeRefs(child.props[refKey], anchorRef);
    return (React.createElement(React.Fragment, null,
        cloneElement(child, __assign(__assign({}, handlers), (_b = {}, _b[refKey] = ref, _b['aria-describedby'] = id, _b))),
        React.createElement(Tooltip, __assign({}, props, { id: id, visible: visible, anchor: anchorRef, onClose: close }), content)));
};
